function AppAuthFactory(
  Subscriber,
  LoopBackAuthGreenback,
  $state,
  $http) {
  "ngInject";

  var purgeCurrentUser = function() {
    LoopBackAuthGreenback.clearUser();
    LoopBackAuthGreenback.clearStorage();
  }

  const setSubscriptionExpirationOffset = function setSubscriptionExpirationOffset(subscription) {
    if(!angular.isUndefined(subscription.expires)) {
      const subscription_expiration_ts = new Date(subscription.expires).getTime();
      const one_day = 24*60*60*1000;
      const subscription_remaining_ts = new Date(subscription_expiration_ts) - new Date().getTime();
      subscription.membership_expires = Math.round(Math.abs(subscription_remaining_ts / one_day));
    }
    else {
      subscription.membership_expires = 0;
    }
  }

  const getCurrentSubscriber = function getCurrentSubscriber(cb, cbErr) {
    Subscriber.findById({
      "id": LoopBackAuthGreenback.currentUserId
    }).$promise.then(cb).catch(cbErr);
  }

  const getAndPersistCurrentUser = function getAndPersistCurrentUser(cb) {
    getCurrentSubscriber(function(userData) {
      userData = userData.toJSON();
      if(userData.error) throw {data: userData};
      Subscriber.getActiveSubscription({
        "id": userData.id
      }).$promise.then(function(result) {
        result = result.toJSON();
        result.subscription = result.subscription || {};
        userData.subscription = result.subscription;
        LoopBackAuthGreenback.currentUserData = userData;
        self.setCurrentUserProperty("subscription", result.subscription);
        cb(null, userData);
      }).catch(function(err) {
        console.error(err);
        cb(err);
      });
    }, function(err) {
      console.error(err);
      cb(err);
    });
  }

  const self = {
    getLoopBackAuthGreenback: function getLoopBackAuthGreenback() {
      return LoopBackAuthGreenback
    },
    login: function login(data, cb) {
      var loginErr;
      purgeCurrentUser();
      Subscriber.login({
        "include":"user"
      },
      {
        email: data.email,
        password: data.password,
        rememberMe: false
      }).$promise.then(function (response) {
        setTimeout(() => {
          self.getCurrentUser(function(err, currentUser) {
            if(!err) {
              LoopBackAuthGreenback.setUser(response.id, response.userId, currentUser);
              LoopBackAuthGreenback.save();
              cb(null, currentUser);
            }
            else {
              cb(err);
            }
          });
        }, 500);
      })
      //failure
      .catch(function () {
        loginErr = new Error('Subuscriber.login() err', arguments);
        cb && cb(loginErr);
      });
    },
    logout: function (cb) {
      purgeCurrentUser();
      cb && cb();
    },
    setCurrentUserProperty: function(key, val) {
      console.log("Setting property", key, val);
      if(key == "subscription") {
        setSubscriptionExpirationOffset(val);
      }
      LoopBackAuthGreenback.setCurrentUserProperty(key, val);
    },
    getCurrentSubscriber,
    getAndPersistCurrentUser,
    getCurrentUser: function(cb) {
      //currentUserData is not saved in sessionData or localStorage
      if((!LoopBackAuthGreenback.currentUserData || !LoopBackAuthGreenback.currentUserData.subscription)
          && LoopBackAuthGreenback.currentUserId
          && LoopBackAuthGreenback.accessTokenId) {
        console.log("Calling API for subscriber instance");
        getAndPersistCurrentUser(cb);
      }
      else if(LoopBackAuthGreenback.currentUserData) {
        console.log("Getting from existing instance");
        cb(null, LoopBackAuthGreenback.currentUserData);
      }
      else {
        cb(null, false);
      }
    }
  };

  return self;
}

export default AppAuthFactory;



// WEBPACK FOOTER //
// ./js/containers/users/services/appAuth.factory.js